module.exports = __webpack_public_path__ + "img/369d4af.jpg";